// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4511":"c2e1e849","4784":"6343c71d","5313":"1623edac","9694":"d82f40c9"}[chunkId] + ".chunk.css";
};